import { render } from "./WIPPanel.vue?vue&type=template&id=a8932418&scoped=true&ts=true"
import script from "./WIPPanel.vue?vue&type=script&lang=ts"
export * from "./WIPPanel.vue?vue&type=script&lang=ts"

import "./WIPPanel.vue?vue&type=style&index=0&id=a8932418&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8932418"]])

export default __exports__